import { formatCurrency, formatCurrencyOne, formatValue } from "../../../common-components/commonFunctions";
import { ytdSalesDataInterface } from "../../../redux/reducers/titleListYTDSalesReducer";

interface SalesDataStructure {
  gross: { units: string; dollars: string };
  returns: { units: string; dollars: string };
  net: { units: string; dollars: string };
  sellThrough: string | number;
}

export const setTitleSalesYearMonthData = (setStats:any, salesData: any) => {
    const data: SalesDataStructure = {
        gross: {
            units: formatCurrencyOne(salesData.Gross_Units),
            dollars: formatCurrency(Math.round(salesData.Gross_Dollars))
        },
        returns: {
            units: formatCurrencyOne(salesData.Returns_Units),
            dollars: formatCurrency(Math.round(salesData.Returns_Dollars))
        },
        net: {
            units: formatCurrencyOne(salesData.Net_Units),
            dollars: formatCurrency(Math.round(salesData.Net_Dollars))
        },
        sellThrough: salesData.Sell_Through_YTD ?? 0
    };
    setStats(data);
}

export const setTitleSalesLTDData = (setStats:any, salesData: any) => {
    const data: SalesDataStructure = {
        gross: {
            units: formatCurrencyOne(salesData.Gross_Units),
            dollars: formatCurrency(Math.round(salesData.Gross_Dollars))
        },
        returns: {
            units: formatCurrencyOne(salesData.Returns_Units),
            dollars: formatCurrency(Math.round(salesData.Returns_Dollars))
        },
        net: {
            units: formatCurrencyOne(salesData.Net_Units),
            dollars: formatCurrency(Math.round(salesData.Net_Dollars))
        },
        sellThrough: salesData.Sell_Through_YTD ?? 0
    };
    setStats(data);
}

export const setTitleSalesYTDData = (setStats:any, salesData: any) => {
    const data: SalesDataStructure = {
        gross: {
            units: formatCurrencyOne(salesData.Gross_Units),
            dollars: formatCurrency(Math.round(salesData.Gross_Dollars))
        },
        returns: {
            units: formatCurrencyOne(salesData.Returns_Units),
            dollars: formatCurrency(Math.round(salesData.Returns_Dollars))
        },
        net: {
            units: formatCurrencyOne(salesData.Net_Units),
            dollars: formatCurrency(Math.round(salesData.Net_Dollars))
        },
        sellThrough: salesData.Sell_Through_YTD ?? 0
    };
    setStats(data);
}